<template>
  <div>
    <v-row class="mr-2">
      <v-col cols="12" md="8" class="flex-items">
        <v-tabs
          show-arrows
          v-model="activeTab"
          color="#147452"
          align-tabs="center"
        >
          <v-tab v-for="tab in tabList" :key="tab.id" @click="changeTab(tab)">{{
            tab.name
          }}</v-tab>
        </v-tabs>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" md="4" class="d-flex justify-space-between">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="search"
          label="Search"
          single-line
          hide-details
          class="rounded-lg"
          color="#239FAB"
          dense
        ></v-text-field>
        <v-btn
          class="white--text ml-2 rounded-lg"
          :color="$vuetify.theme.themes.light.submitBtns"
          v-if="this.$store.state.user.user.isAdminApproved == 1"
          @click="add()"
        >
          <v-icon left> mdi-plus-box-outline </v-icon>
          Add New
        </v-btn>
      </v-col>
    </v-row>
    <v-card class="ma-5 dt-container" elevation="0" outlined>
      <v-row>
        <v-col cols="12" md="9" class="flex-items my-3 ">
          <v-tabs
            v-model="activeBureau"
            color="#147452"
            show-arrows
            align-tabs="center"
          >
            <v-tab
              v-for="bureau in bureauList"
              :key="bureau.id"
              @click="changeBureau(bureau)"
              >{{ bureau.name }}</v-tab
            >
          </v-tabs>
        </v-col>
        <v-col
          cols="12"
          md="3"
          class="flex-items mt-5 justify-center"
          v-if="bureau == 1"
        >
          <div>
            <v-autocomplete
              outlined
              v-model="institute"
              dense
              class="rounded-lg"
              item-text="name"
              item-value="id"
              label="Institute"
              color="#6DB249"
              :items="instituteList"
              @change="changeInstitute()"
            >
            </v-autocomplete>
          </div>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="data"
        :items-per-page="10"
        :search="search"
        :options.sync="options"
        :loading="loading"
        @pagination="pagination"
        hide-default-footer
      >
        <template v-slot:[`item.position`]="{ item }">
          <v-chip class="ma-2 white--text" x-small color="green">
            {{
              item.position == 1
                ? "Chairperson"
                : item.position == 2
                ? "Vice-Chairperson"
                : "Member"
            }}
          </v-chip>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <div class="text-no-wrap" style="padding: 4px;">
            <v-btn color="#93CB5B" x-small outlined @click="editItem(item)">
              <v-icon size="14">mdi-pencil</v-icon> Update
            </v-btn>
            <v-btn
              x-small
              color="#C62828"
              class="white--text mx-1"
              @click="confirmDelete(item)"
            >
              <v-icon size="14">mdi-trash-can-outline</v-icon> Delete
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-row class="mb-2 mx-5" align="center">
      <v-col cols="auto" class="mr-auto text-truncate flex-items" no-gutters>
        <span class="px-2">Show</span>
        <span>
          <v-select
            dense
            outlined
            color="#147452"
            hide-details
            :value="options.itemsPerPage"
            style="max-width: 90px"
            class="rounded-lg"
            @change="options.itemsPerPage = parseInt($event, 10)"
            :items="perPageChoices"
          >
          </v-select>
        </span>
        <span class="px-2"> Entries </span>
      </v-col>

      <v-col cols="auto" class="mr-auto text-truncate" no-gutters>
        Showing {{ paginationData.pageStart + 1 }} to
        {{ paginationData.pageStop }} of
        {{ paginationData.itemsLength }} entries
      </v-col>
      <v-col cols="auto">
        <v-pagination
          v-model="options.page"
          class="rounded-lg"
          :total-visible="7"
          :color="$vuetify.theme.themes.light.submitBtns"
          :length="paginationData.pageCount"
        >
        </v-pagination>
      </v-col>
    </v-row>

    <CollegeEvaluationReviewCommitteeDialog
      :data="cercData"
      :action="action"
      :tab="tab"
      :bureau="bureau"
    />

    <v-dialog v-model="confirmDialog" persistent max-width="350">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
            Are you sure you want to proceed?
          </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="confirmDialog = false">
            Close
          </v-btn>
          <v-btn color="#147452" class="white--text" @click="deleteItem()">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="5000"
    ></fade-away-message-component>
  </div>
</template>
<script>
export default {
  components: {
    CollegeEvaluationReviewCommitteeDialog: () =>
      import(
        "../../components/Dialogs/Forms/CollegeEvaluationReviewCommittee/CollegeEvaluationReviewCommitteeDialog.vue"
      ),
  },
  data: () => ({
    search: "",
    cercData: null,
    headers: [
      {
        text: "Name",
        value: "name",
        align: "start",
        valign: "start",
        sortable: false,
      },

      {
        text: "Office",
        value: "office_name",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Position",
        value: "position",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Year",
        value: "year",
        align: "center",
        valign: "center",
        sortable: false,
      },
      {
        text: "Action",
        value: "action",
        align: "center",
        valign: "center",
        sortable: false,
        width: 100,
      },
    ],
    data: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    instituteList: [],
    institute: 0,
    activeTab: { id: 1, name: "College Evaluation Committee" },
    tab: 1,
    tabList: [
      { id: 1, name: "College Evaluation Committee" },
      { id: 2, name: "College Review Committee" },
    ],
    activeBureau: { id: 1, name: "Bureau A (Teaching Personnel)" },
    bureau: 1,
    bureauList: [
      { id: 1, name: "Bureau A (Teaching Personnel)" },
      { id: 2, name: "Bureau B (Non-Teaching Personnel)" },
    ],
    deleteData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    confirmDialog: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),

  mounted() {
    this.eventHub.$on("closeEvaluationReviewDialog", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeEvaluationReviewDialog");
  },

  watch: {
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
    filterYear: {
      handler(newData, oldData) {
        if (oldData != newData) {
          this.initialize();
        }
      },
      deep: true,
    },
  },
  computed: {
    filterYear() {
      return this.$store.getters.getFilterSelected;
    },
  },
  methods: {
    pagination(data) {
      this.paginationData = data;
    },
    getInstitutes() {
      this.axiosCall("/institutes", "GET").then((res) => {
        let data = res.data;
        data.push({ id: 0, name: "All Committee Member" });
        this.instituteList = data;
      });
    },

    initialize() {
      this.loading = true;
      let filter = this.$store.getters.getFilterSelected;
      this.getInstitutes();
      console.log("Filted", filter);
      this.axiosCall(
        "/evaluation-review-committee/personnelBureau/" +
          this.tab +
          "/" +
          filter +
          "/" +
          this.bureau +
          "/" +
          this.institute,
        "GET"
      ).then((res) => {
        if (res) {
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].name = this.toTitleCase(res.data[i].name);
          }
          this.data = res.data;
          this.loading = false;
        }
      });
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    changeBureau(tab) {
      this.activeBureau = tab;
      this.bureau = tab.id;
      this.initialize();
    },
    changeInstitute() {
      this.initialize();
    },
    add() {
      this.cercData = [{ id: null }];
      this.action = "Add";
    },
    editItem(item) {
      this.cercData = item;
      this.action = "Update";
    },

    deleteItem() {
      // alert(this.deleteData.id);
      this.axiosCall(
        "/evaluation-review-committee/" + this.deleteData.id,
        "DELETE"
      ).then((res) => {
        if (res.data.status == 200) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.confirmDialog = false;
          this.initialize();
        } else if (res.data.status == 400) {
          this.confirmDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },
    confirmDelete(item) {
      this.confirmDialog = true;
      this.deleteData = item;
    },
  },
};
</script>
